import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito herramientas especiales?',
    a: 'No, solo tus manos y un poco de aceite corporal o crema.'
  }, {
    q: '¿Cuánto tiempo tardan los resultados?',
    a: 'La ligereza es inmediata; la reducción de medidas se nota desde la primera sesión completa de 15 minutos.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'No, el manual está diseñado con lenguaje sencillo y pasos visuales para que cualquier persona pueda hacerlo en su habitación.'
  }, {
    q: '¿Puedo hacerlo si tengo cesárea?',
    a: 'Sí, siempre que la cicatriz esté totalmente cerrada y tengas el alta médica para masajes.'
  }, {
    q: '¿Qué pasa si tengo poco tiempo?',
    a: 'La rutina de oro está optimizada para hacerse en 15 minutos, incluso mientras miras televisión o después de la ducha.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-[#FDF8F0]" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F]" data-id="element-71">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-72">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-[#C8956C]/20 overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-74">
                <span className="font-bold text-[#3D2B1F] pr-4" data-id="element-75">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-[#C8956C] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-78">
                    <div className="px-6 pb-4 text-[#5A4332]" data-id="element-79">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}